// Post-purchase rules-specific table state mappings

export const postPurchaseRulesFilterMapping = {
    // No filters currently supported by the API
};

export const postPurchaseRulesQueryParamsMapping = {
    // No query params currently supported
};

// Sort field mappings for post-purchase rules (frontend column ID -> backend sort field)
// Note: Backend sorting is fixed (priority DESC NULLS LAST, then createdAt with sort_order)
export const postPurchaseRulesSortMapping = {
    id: 'createdAt' as const,
    priority: 'priority' as const,
    ruleOperator: 'createdAt' as const,
    createdAt: 'createdAt' as const,
} as const;

